/*
Copyright (c) 2020 by Stevie. All Rights Reserved.
*/
import React, { useState, useCallback, useEffect, } from 'react';
import { Link, Switch, Route, useLocation, useHistory } from 'react-router-dom';
import { Layout, Button } from 'antd';
import HualiMenu from './HualiMenu';
import HualiContent from './HualiContent';
import { LogoImg } from '../Components'
import { Tabs, Tab } from '@mui/material';
import Atuh from '../Pages/Login'
import GlobalStyles from "@mui/material/GlobalStyles";
import config from './config';
import { StyledLayout, TitleFont } from '../../libs/base/base-style'
import { styled } from '@mui/material/styles';
import { split, join, slice } from 'lodash';
import { useAuthStore } from '../../stores/auth';
import { useObserver, observer } from 'mobx-react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Calendar from '../Pages/Calendar/'
const { Header, Sider, Content } = Layout;

const Container = styled(Grid)`
  border-bottom:1px solid #1E7F99;
`
const Logo = styled(LogoImg)`
  width: 152px !important;
  height:89px !important;
  padding: 17px 0px;

`;


const StyledTop = styled(Grid)`
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.1);
  height: 64px;
`;

const Trigger = styled(Button)`
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;

  :hover {
    color: #1890ff;
  }
`;

const StyledContent = styled(Content)`
  margin: 0;
  padding: 0;

`;
// TODO @changran remove important
const StyledHeader = styled(Header)`
  height:50px !important;
  padding: 0 !important;
  background: linear-gradient(90deg,#004C55 0%, #0F5D5A 24%, #0E616A 53%, #176D71 70%, #0A6884 100% );
`;

const StyledSider = styled(Sider)`
  background:linear-gradient(12deg,#0A6884 0%,#176D71 24%,#0E616A 53%,#0F5D5A 70%, #004C55 0%);

`
const EqTabs = styled(Tabs)({
  fontSize: '20px',
  marginBottom: '20px'
});


const EqTab = styled(Tab)({
  fontSize: '1.5rem',
  '&.Mui-selected': {
    color: '#408697',
  },
});
const theme = createTheme({
  components: {
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       padding: '0 !important',
    //       backgroundColor: 'initial !important',
    //       fontFamily: '"Roboto","Helvetica","Arial",sans-serif !important'
    //     },
    //   },
    // },
  },
});
const IS_SIDE = false
export const Main = () => {
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = useCallback(() => {
    setCollapsed(!collapsed)
    console.log('onClick....')
  }, [
    setCollapsed,
    collapsed,
  ]);
  const pathParts = split(pathname, '/');
  const firstPart = slice(pathParts, 1, 2).map(item => '/' + item);
  const firstAndSecondPart = slice(pathParts, 0, 3);
  const activeKey = join(firstAndSecondPart, '/');

  const location = useLocation();

  const tabNameToIndex = {
    "/": 0,
    "/eventCalendar": 1
  };

  const indexToTabName = ["", "eventCalendar"];
  const [selectedTab, setSelectedTab] = React.useState(tabNameToIndex[location.pathname]);
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  React.useEffect(() => {
    // 当组件加载时，会打印当前的路径
    console.log(location.pathname);
  }, [location]);
  return (
    <ThemeProvider theme={theme}>
      {IS_SIDE &&
        <StyledSider trigger={null} collapsible collapsed={collapsed}>
          <Link
            to={{
              pathname: '/',
            }}
          ><Container><Logo /></Container>

          </Link>
          <HualiMenu
            config={config}
            defaultOpenKeys={firstPart}
            selectedKeys={[activeKey]}
          />
        </StyledSider>
      }

      <StyledLayout>
        <StyledContent>
          <HeaderWrapper>
            {location.pathname != '/events/' ?
              <EqTabs value={selectedTab} onChange={handleChange} TabIndicatorProps={{ style: { backgroundColor: "#408697" } }}>
                <Tab label="EquiManage Listing" component={Link} to={`/${indexToTabName[0]}`} sx={{
                  fontSize: '1.5rem',

                  '&.Mui-selected': {
                    color: '#408697',
                  },
                }} />
                <Tab label="EquiManage Horse Calendar" component={Link} to={`/${indexToTabName[1]}`} sx={{
                  fontSize: '1.5rem',
                  '&.Mui-selected': {
                    color: '#408697',
                  },

                }} />
              </EqTabs>

              : null
            }
          </HeaderWrapper>
          <HualiContent config={config} />
        </StyledContent>
      </StyledLayout>

    </ThemeProvider>
  );
};

const StyledFont = styled(TitleFont)(({ theme }) => ({

  borderBottom: 'solid 3px #408697',
  height: '40px',
  marginBottom: '16px',
  marginRight: '16px',
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
const HeaderWrapper = styled(Grid)`
    display:flex;
    justify-content: center;
    align-items:center;
    
`

export default observer(() => {
  return <StyledLayout>
    <Switch>
      <Route key={'/'} path={'/'} component={Main} />

    </Switch>

  </StyledLayout>


})
